module.exports = __webpack_public_path__ + "img/document-file-table.e3a80deb.svg";